import { func } from 'prop-types'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import React, { Fragment, useEffect, useState } from 'react'

import { empty } from '../../../../../../utils/helpers/helpers'
import { useGlobal } from '../../../../../../contexts/GlobalContext'
import { geraPergundaSatisfacaoClube, LEGENDA_NIVELAMENTO, LISTA_NOTAS } from './constantsNivelSatisfacao'

const estiloItemAtivo = `
  border-color: ${StyleGuide.cores.cinza500};
  border-radius: 5px;
`

const NivelSatisfacaoWrapper = styled.div`
  .pergunta {
    ${StyleGuide.tipografia.textoDefault}
    margin: 0 0 5px;
  }

  small {
    ${StyleGuide.tipografia.textoPequeno}
    color: ${StyleGuide.cores.cinza400};
  }

  .avaliacao__list {
    align-items: center;
    display: flex;
    margin-top: 20px;
    width: 100%;
  }
`

const AvaliacaoItem = styled.li`
  border: 1px solid ${StyleGuide.cores.branco};
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-height: 50px;
  padding: 5px 0 10px;
  transition: .4s ease-in-out;
  width: 35px;
  ${( { ativo } ) => ativo && estiloItemAtivo};

  &:hover {
    ${estiloItemAtivo};
  }

  p {
    margin: 0 0 10px;
    text-align: center;
    width: 100%;
  }
`

const Color = styled.div`
  background-color: ${( { cor } ) => cor && cor};
  border-radius: 100%;
  height: 12px;
  width: 12px;
`

const NivelSatisfacao = ( { handleChange } ) => {
  const [ pergunta, setPergunta ] = useState( null )
  const [ avaliacao, setAvaliacao ] = useState( null )
  const { modalidadeURL } = useGlobal()

  useEffect( () => {
    const perguntaGerada = geraPergundaSatisfacaoClube( modalidadeURL )
    if ( !empty( perguntaGerada ) ) {
      setPergunta( perguntaGerada )
    }
  }, [] )

  useEffect( () => {
    if ( handleChange ) {
      handleChange( avaliacao )
    }
  }, [ avaliacao ] )

  return (
    <NivelSatisfacaoWrapper>
      { pergunta ?
        <Fragment>
          <p className="pergunta"> { pergunta } </p>

          <small> { LEGENDA_NIVELAMENTO } </small>

          <ul className="avaliacao__list">
            { LISTA_NOTAS.length ? LISTA_NOTAS.map( item => (
              <AvaliacaoItem
                ativo={ avaliacao ? avaliacao === item.nota : null }
                key={ item.nota }
                onClick={ () => {
                  setAvaliacao( item.nota )
                } }
              >
                <p> { item.nota } </p>

                <Color cor={ item.cor } />
              </AvaliacaoItem>
            ) ) : null }
          </ul>
        </Fragment> : null}
    </NivelSatisfacaoWrapper>
  )
}

NivelSatisfacao.propTypes = {
  'handleChange': func.isRequired
}

export default NivelSatisfacao

